module.exports = __webpack_public_path__ + "img/chart.378a4a2.png";